import {
  parseCookies,
  setCookie as nookiesSet,
  destroyCookie as nookieDestroy,
} from 'nookies'
import type { NextPageContext } from 'next'
import { hasConsentForCategory } from './consentManager'
import { CookieCategory } from './CookieCategory'

type Params = Parameters<typeof nookiesSet>
export type CookieSerializeOptions = Params[3]

export { CookieCategory }

export const getCookies = (ctx: NextPageContext): { [k: string]: string } =>
  parseCookies(ctx)

export const getCookie = (
  ctx: NextPageContext,
  name: string,
): string | undefined => parseCookies(ctx)[name]

/**
 * Sets a cookie in the browser
 * > **DISCLAIMER:** Setting a non-strictly necessary cookie before the cookie banner has been accepted will not work!
 * > Please speak to the Web Enablement team if you need to set a non-strictly necessary cookie that happens on page load.
 * @param name - The name of the cookie
 * @param value - The value of the cookie
 * @param options - The options for the cookie
 * @param ctx - The context of the cookie
 * @param category - The OneTrust category of the cookie, defaults to STRICTLY_NECESSARY
 */
export const setCookie = (
  name: string,
  value: string,
  /* istanbul ignore next */
  options: CookieSerializeOptions = {},
  ctx: NextPageContext,
  category: CookieCategory,
) => {
  if (hasConsentForCategory(category)) {
    // istanbul ignore next
    return nookiesSet(ctx || null, name, value, options)
  }
  return false
}

/**
 * Sets a cookie in the browser
 * > **DISCLAIMER:** Setting a non-strictly necessary cookie before the cookie banner has been accepted will not work!
 * > Please speak to the Web Enablement team if you need to set a non-strictly necessary cookie that happens on page load.
 * @param name - The name of the cookie
 * @param value - The value of the cookie
 * @param options - The options for the cookie
 * @param category - The OneTrust category of the cookie, defaults to STRICTLY_NECESSARY
 */
export const setBrowserCookie = (
  name: string,
  value: string,
  /* istanbul ignore next */
  options: CookieSerializeOptions = {},
  category: CookieCategory,
) => {
  if (hasConsentForCategory(category)) {
    return nookiesSet(null, name, value, options)
  }
  return false
}

export const getBrowserCookies = (): { [k: string]: string } => parseCookies()

export const getBrowserCookie = (name: string): string | undefined =>
  parseCookies()[name]

export const destroyCookie = (
  name: string,
  /* istanbul ignore next */
  options: CookieSerializeOptions = {},
  ctx: NextPageContext,
) => {
  nookieDestroy(ctx, name, options)
}

export const destroyBrowserCookie = (
  name: string,
  /* istanbul ignore next */
  options: CookieSerializeOptions = {},
) => {
  nookieDestroy(undefined, name, options)
}
